import React from "react"
import './404Page.scss';

const NotFoundPage: React.FC = () => {
    return (
        <div className="not-found-page">404</div>
    )
}
export default NotFoundPage
